import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_walking_gs_indoor_intent~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_walking_gs_indoor_intent_b'
					),
			},
		},
	},
	{
		'main-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_walking_gs_indoor_intent~2
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_walking_gs_indoor_intent_c'
					),
			},
		},
	},
]

export default config
